import * as React from "react"
import type { SVGProps } from "react"
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10.5 17.86a6.3 6.3 0 0 1-4.61-1.89A6.3 6.3 0 0 1 4 11.36q0-2.73 1.89-4.61a6.3 6.3 0 0 1 4.61-1.9q2.72 0 4.61 1.9a6.3 6.3 0 0 1 1.89 4.6 6 6 0 0 1-1.3 3.8l3.6 3.6a1 1 0 0 1 .28.7 1 1 0 0 1-.28.7 1 1 0 0 1-.7.28 1 1 0 0 1-.7-.27l-3.6-3.6a6 6 0 0 1-3.8 1.3m0-2q1.87 0 3.19-1.32A4.3 4.3 0 0 0 15 11.37q0-1.87-1.31-3.19a4.3 4.3 0 0 0-3.19-1.31q-1.87 0-3.19 1.31C6 9.48 6 10.11 6 11.36q0 1.87 1.31 3.19c1.31 1.31 1.94 1.3 3.19 1.3" />
  </svg>
)
export default SvgSearch
